<template>
  <div style="height:100%;width: 100%;overflow-x:hidden;overflow-y: scroll;background-color: #d3dce6"
       @click="handleClick">
    <!--        第一行-->
    <div class="div1-mcu">
      <img src="../../public/image/浙江纵海4.jpg" alt="" width="100%">
    </div>
    <!--    第二行：联系名片-->
    <div class="div2-mcu">
      <div class="div2-div1-mcu">
        <br>
        <a style="font-size: 20px;color: #2c3e50"><strong>浙江纵海自动化设备有限公司</strong></a>
        <br><br>
        <div style="text-align: center;width: 100%;font-size: 15px">
          联系人：{{this.$store.state.contactIntroduce.personName}}<br>
          手机：{{this.$store.state.contactIntroduce.phoneNumber}}<br>
          电话：{{this.$store.state.contactIntroduce.telephoneNumber}}<br>
          传真：{{this.$store.state.contactIntroduce.facsimileNumber}}<br>
          邮箱：{{this.$store.state.contactIntroduce.email}}<br>
          地址：{{this.$store.state.contactIntroduce.address}}<br><br>
        </div>
        <div>
          <el-button @click="phoneConsult" v-clipboard="copyPhone" type="primary">拨打手机</el-button>
          <el-button @click="telephoneConsult" v-clipboard="copyTelephone" type="primary">拨打电话</el-button>
          <br><br>
        </div>
      </div>
    </div>
    <!--    第三层：公司所在位置-->
    <div class="div3-mcu">
      <a style="font-size: x-large;font-family: 楷体"><strong>公司所在位置地图显示</strong></a><br><br>
    </div>
    <!--    第四层:地图行-->
    <div class="div4-mcu">
      <div id="mapContainer" class="div4-div1-mcu">

      </div>
    </div>

    <!--    第八层：底框-->
    <div class="div9-MFP">
      <div class="div9-div1-MFP">
        <a class="div9-a1-MFP">联系人：{{this.$store.state.contactIntroduce.personName}}</a><br>
        <a class="div9-a1-MFP">联系方式：{{this.$store.state.contactIntroduce.phoneNumber}}</a><br>
        <a class="div9-a1-MFP">邮箱：{{this.$store.state.contactIntroduce.email}}</a><br>
        <a class="div9-a1-MFP">地址：{{this.$store.state.contactIntroduce.address}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a class="div9-a2-MFP" href="https://beian.miit.gov.cn/" target="_blank">{{this.$store.state.contactIntroduce.recordNumber}}</a><br>
        <a class="div9-a2-MFP" href="http://www.beian.gov.cn/portal/registerSystemInfo?recordcode=33108202000840" target="_blank">{{this.$store.state.contactIntroduce.policeRecordNumber}}</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a style="font-family: Avenir">Copyright © 2024</a><br>
        <a>版权所有©浙江纵海自动化设备有限公司</a><br>
      </div>
      <div class="div9-div2-MFP">
        <a>声明:本站部分数据来源于互联网,与本公司无关,若有侵权请联系客服删除。</a>
      </div>
    </div>

  </div>
</template>

<script>
  import '../css/mobile/MCU_MobileContactUs.css'
  import AMapLoader from '@amap/amap-jsapi-loader'

  window._AMapSecurityConfig = {
    securityJsCode: '048ea503503e30e576588e9b50b7651d'
  }
  export default {
    name: "MobileContactMe",
    data() {
      return {
        //手机号，电话号，传真，邮箱，地址
        copyPhone: '15381800010',
        copyTelephone: '057685286661',
        copyFacsimile: '057685286661',
        copyEmail: '804821@qq.com',
        copyAddress: '浙江省临海市沙段村1-83号',
        //声明地图
        map: null,
      }
    },
    mounted() {
      //DOM初始化完成进行地图初始化
      this.initMap();
      this.scrollToTop();
    },
    components: {},
    methods: {
      //拨打手机,电话
      phoneConsult(){
        window.location.href='tel://15381800010';
      },
      telephoneConsult(){
        window.location.href='tel://057685286661';
      },
      //滚动置顶方法
      scrollToTop() {
        const position = 0;
        this.$refs.scrollContainer.scrollTop = position;
      },
      //复制点击按钮
      clickCopy(id) {
        let messageString = '';
        if (id == 0) {
          messageString = '手机号：' + this.copyPhone;
        } else if (id == 1) {
          messageString = '电话号：' + this.copyTelephone;
        } else if (id == 2) {
          messageString = '传真号：' + this.copyFacsimile;
        } else if (id == 3) {
          messageString = '邮箱号：' + this.copyEmail;
        } else if (id == 4) {
          messageString = '地址：' + this.copyAddress;
        } else {
          messageString = '-1';
        }
        if (messageString != '-1') {
          this.$message({
            message: '成功将 ' + messageString + ' 复制到粘贴板!',
            type: 'success',
          });
        } else {
          this.$message({
            message: '复制失败！',
            type: 'error',
          });
        }

      },
      //初始化地图
      initMap() {
        AMapLoader.load({
          key: '2a535c0231c0ce304c275184892038e0', // 申请好的Web端开发者Key，首次调用 load 时必填
          version: '2.0', // 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
          plugins: ['AMap.ToolBar', 'AMap.Scale', 'AMap.LngLat', 'AMap.Marker', 'AMap.Geolocation'] // 需要使用的的插件列表，如比例尺'AMap.Scale'等
        }).then(AMap => {
          this.map = new AMap.Map('mapContainer', {
            //设置地图容器id
            viewMode: '3D', //是否为3D地图模式
            zoom: 8, //初始化地图级别
            center: [121.58497,28.938001] //初始化地图中心点位置
          })
          //添加toolbar工具条插件
          const toolbar = new AMap.ToolBar();
          this.map.addControl(toolbar);
          //添加Scale工具条插件
          const Scale = new AMap.Scale();
          this.map.addControl(Scale);
          // 创建红色图标
          const icon = new AMap.Icon({
            size: new AMap.Size(50, 25), // 图标尺寸
            image: 'https://a.amap.com/jsapi_demos/static/demo-center/icons/poi-marker-red.png', // 图标的URL
            imageSize: new AMap.Size(25, 25), // 图标所用图片尺寸
            anchor: 'bottom-center', // 图标定位偏移量
            anchor_y: 25 // 图标定位偏移量的Y值
          });
          // 添加红色点标记
          const marker = new AMap.Marker({
            map: this.map,
            position: [121.059509, 28.945164], // 点标记位置
            icon: icon,
            offset: new AMap.Pixel(-25, -25) // 修改默认标记位置
          });
          marker.setMap(this.map);
          // 设置鼠标划过点标记显示的文字提示
          // marker.setTitle(this.$store.state.contactIntroduce.address);
          // 设置label标签
          // label默认蓝框白底左上角显示，样式className为：amap-marker-label
          marker.setLabel({
            direction:'right',
            offset: new AMap.Pixel(0, 0),  //设置文本标注偏移量
            content: "<div class='info'>"+this.$store.state.contactIntroduce.address+"</div>", //设置文本标注内容
          });
        }).catch(e => {
          console.log(e)
        })
      },
      handleClick() {
        let that = this;
        if(that.$store.state.isShowNav==true){
          that.$store.state.isShowNav = false;
        }
      }
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/mobile/MobileContactUs.vue